/* eslint-disable @typescript-eslint/no-explicit-any */
import type { MutableRefObject } from 'react';
import { useEffect } from 'react';

export const useClickOutside = (ref: MutableRefObject<any>, action: () => void) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        action();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
};
